import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';
// Import enumerations.
import {
	BreakpointWidth,
} from '@app/enumerations';

const useStyles = makeStyles((theme: Theme) => {

	return createStyles({
		formPopupAddPolicyNote_container: {
			display: 'flex',
			flexDirection: 'column',
		},
		formPopupAddPolicyNote_noteDetailsWrapper: {

		},
		formPopupAddPolicyNote_noteDetails: {
			display: 'flex',
			'& > div:first-child': {
				[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
					marginRight: theme.spacing(2),
				},
				width: '100%',
			},
			'& > div:last-child': {
				[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
					marginLeft: theme.spacing(2),
				},
				width: '100%',
			},
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				flexDirection: 'row',
			},
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				flexDirection: 'column',
			},
		},
		formPopupAddPolicyNote_noteSection: {
			display: 'flex',
			flexDirection: 'column',
		},
		formPopupAddPolicyNote_inputWrapper: {
			padding: theme.spacing(2, 0),
		},
		formPopupAddPolicyNote_fileInputWrapper: {
			height: '100%',
		},
		formPopupAddPolicyNote_collapse: {
			minHeight: 'auto !important',
		},
	});
});

export default useStyles;
